// API base settings
export const BASE_API_PATH = process.env.BASE_API_PATH || '';
export const PRODUCT_COUNT_PER_PAGE = 60;

// Debug options
export const DEBUG_PARAM = 'dbg'; // Add this to URL if get debugged version of page
